(() => {
  (() => {
    class t extends HTMLElement {
      currentVariant;
      form;
      swatch;
      input;
      prices;
      priceDiscount;
      specialDiscount;
      option0;
      option1;
      option2;
      option3;
      imageBar;
      stars;
      button;
      SignButton;
      save_additional;
      affirmText;
      gallery;
      gallery2;
      nGallery;
      nVideo;
      image;
      select;
      noSelect;
      options;
      wrapper;
      afterPayPrice;
      additionalText;
      shopBarToggles;
      quantitySelector;
      constructor() {
        super(),
          (this.currentVariant = window.theme.product.currentVariant),
          (this.form = this.querySelector("form")),
          (this.swatch = this.querySelector("#variantPicker")),
          (this.save_additional = this.querySelector(
            ".discount-additional-text"
          )),
          (this.input = this.form.querySelector('input[name="id"]')),
          (this.prices = this.querySelectorAll(".product-price")),
          (this.priceDiscount = this.querySelectorAll(
            ".product-price-discount"
          )),
          (this.specialDiscount = this.querySelectorAll(
            ".special-discount-item"
          )),
          (this.imageBar = document.querySelector(".shop-bar_image")),
          (this.shopBarToggleContainer = document.querySelector(".shop-bar-toggle-container")),
          (this.productFormContainer = document.querySelector(".product__info-container")),
          (this.shopBarClose = document.querySelector(".shop-bar-close")),
          (this.stars = this.querySelector("[data-oke-star-rating]")),
          (this.button = this.querySelector(".product-form__submit")),
          (this.SignButton = this.querySelector(".signup-btn")),
          (this.affirmText = this.querySelector(".affirm-as-low-as")),
          (this.gallery = document.querySelector(
            "product-form .product-gallery"
          )),
          (this.gallery2 = document.querySelector(
            ".product-gallery-grid .product-gallery"
          )),
          (this.nGallery = document.querySelector(".product-gallery-grid")),
          (this.nVideo = document.querySelector(
            ".product-gallery-grid .product-gallery_item-video"
          )),
          (this.wrapper = document.querySelector(".product__info-wrapper")),
          (this.shopBarToggleMobile = document.querySelector("#shop-bar-toggle-mobile")),
          (this.additionalText = document.querySelector(
            "#product-form_additional-text"
          )),
          (this.afterPayPrice = document.querySelector(".afterpay-price")),
          (this.productLabel = document.querySelector(
            "#best-seller-label-pdp"
          )),
          (this.submitting = !1),
          (this.shopBarToggles = this.querySelectorAll(".shop-bar-toggle")),
          (this.quantitySelector = this.querySelector(".quantity")),
          "Gift Card" === window.theme.product.type &&
            ((this.image = document.querySelector(
              "product-form .product-gallery img"
            )),
            (this.select = this.swatch.querySelector(
              ".blanket-options_select"
            )),
            (this.noSelect = !0),
            this.select.addEventListener(
              "click",
              this.handleSelect.bind(this)
            )),
          this.swatch &&
            ((this.option0 = this.swatch.querySelector(
              ".product_option0-value"
            )),
            (this.option1 = this.swatch.querySelector(
              ".product_option1-value"
            )),
            (this.option2 = this.swatch.querySelector(
              ".product_option2-value"
            )),
            (this.option3 = this.swatch.querySelector(
              ".product_option3-value"
            )),
            this.swatch.addEventListener(
              "change",
              this.onVariantChange.bind(this)
            ),
            (this.firstLoad = !0),
            this.onVariantChange(),
            this.showOnlyAvailableColors()),
          this.form.addEventListener("submit", this.handleForm.bind(this)),
          this.classList.contains("shop-bar-disabled") ||
            window.addEventListener("scroll", this.handleScroll.bind(this)),
          this.stars &&
            this.stars.addEventListener("click", () => {
              const t = document.querySelector(
                "[data-oke-carousel], [data-oke-widget]"
              );
              t &&
                window.scrollTo({ top: t.offsetTop - 70, behavior: "smooth" });
            }),
          this.handleLables(),
          this.shopBarClose.addEventListener("click", () => {
            this.productFormContainer.classList.remove("active");
          }),
            this.shopBarToggleMobile.addEventListener("click", () => {
              this.productFormContainer.classList.toggle("active");
            });
            this.initUpsell();
        }

        initUpsell() {
          if (!window.theme || !window.theme.product || !window.theme.product.id) return;
          const productId = window.theme.product.id;
          
          const findContainer = () => {
             const container = this.querySelector('.product-upsell-wrapper');
             if (container) return container;
             return null;
          };

          const container = findContainer();
          if (!container) {
             console.warn('Upsell container not found immediately.');
             return;
          }

          // Fetch data from our custom JSON section to get metafields
          fetch(window.Shopify.routes.root + `recommendations/products?section_id=upsell-json&product_id=${productId}&limit=3&intent=related`)
            .then(response => response.text())
            .then(text => {
              // Parse the HTML to find our JSON
              const parser = new DOMParser();
              const doc = parser.parseFromString(text, 'text/html');
              const jsonContainer = doc.querySelector('[data-upsell-json]');
              
              if (!jsonContainer) return;

              let data;
              try {
                data = JSON.parse(jsonContainer.innerText.trim());
              } catch (e) {
                console.error("Error parsing upsell JSON", e);
                return;
              }

              const products = data.products;

              if (products && products.length > 0) {
                let html = '<div class="upsell-header">Complete your sleep set:</div>';
                let hasAvailable = false;
                
                products.forEach(product => {
                  if (!product.available) return;
                  
                  // Filter out variants that are OOS or Hidden
                  const hiddens = product.hiddens || [];
                  const validVariants = product.variants.filter(v => {
                    // Check availability
                    if (!v.available) return false;
                    
                    // Check hidden metafields against option values
                    // Note: 'hiddens' usually contains the option value strings
                    if (hiddens.includes(v.option1)) return false;
                    if (v.option2 && hiddens.includes(v.option2)) return false;
                    if (v.option3 && hiddens.includes(v.option3)) return false;
                    
                    return true;
                  });

                  if (validVariants.length === 0) return;
                  hasAvailable = true;
                  
                  const firstAvailableVariant = validVariants[0];
                  const image = product.featured_image || ''; 
                  const title = product.title;
                  
                  // Helper to format price
                  const formatPrice = (cents) => '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
                  let priceDisplay = formatPrice(firstAvailableVariant.price);

                  // Variant Options Logic
                  let optionsHtml = '';
                  
                  if (product.variants.length > 1 && product.options.length > 0) {
                    optionsHtml = `<div class="upsell-variant-options">`;
                    
                    product.options.forEach((option, index) => { // option is just string name in standard JSON, but in our custom JSON it might be object if we mapped it. Check upsell-json.liquid.
                      // In upsell-json.liquid: "options": {{ product.options | json }} -> ["Size", "Color"]
                      // Wait, product.options in Liquid outputs just names if used directly? No, it outputs strings array.
                      // Adjusting JS to handle array of strings.
                      
                      const optionName = typeof option === 'string' ? option : option.name;
                      const isColor = optionName.toLowerCase() === 'color' || optionName.toLowerCase() === 'colour';
                      
                      const activeValue = firstAvailableVariant.options[index];

                      // Get unique valid values for this option from our VALID variants only
                      const validValues = [...new Set(validVariants.map(v => v.options[index]))];
                      
                      // If only 1 valid value exists for this option, and it's not the only option, maybe simple text? 
                      // User wants selectors. Let's keep selectors if > 1 valid value OR if it's a multi-variant product generally.
                      // But if validValues has only 1 item, a dropdown is redundant but consistent.
                      
                      if(validValues.length > 0) {
                          // Custom Select HTML
                          optionsHtml += `
                            <div class="upsell-custom-select" data-option-index="${index}" data-option-name="${optionName}">
                              <div class="upsell-custom-trigger" tabindex="0">
                                <span>
                                  ${activeValue}
                                  ${isColor ? `<span class="upsell-swatch color-${activeValue.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '')}"></span>` : ''}
                                </span>
                                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" class="icon-chevron-down">
                                  <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                              </div>
                              <div class="upsell-custom-options">
                                ${validValues.map(value => {
                                  const isSelected = value === activeValue ? 'selected' : '';
                                  return `
                                    <div class="upsell-custom-option ${isSelected}" data-value="${value}">
                                      ${value}
                                      ${isColor ? `<span class="upsell-swatch color-${value.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '')}"></span>` : ''}
                                    </div>
                                  `;
                                }).join('')}
                              </div>
                            </div>
                          `;
                      }
                    });
                    
                    optionsHtml += `</div>`;
                  }

                  // Embed valid variants data safely as JSON string in data attribute
                  const variantsJson = JSON.stringify(validVariants).replace(/"/g, '&quot;');

                  html += `
                    <div class="upsell-card" data-variant-id="${firstAvailableVariant.id}" data-variants="${variantsJson}">
                      <div class="upsell-top-row">
                        <img src="${image}" alt="${title}" class="upsell-image">
                        <div class="upsell-info-main">
                          <h4>${title}</h4>
                          <div class="upsell-price">${priceDisplay}</div>
                        </div>
                        <div class="upsell-checkbox">
                          <input type="checkbox" id="upsell-${firstAvailableVariant.id}" value="${firstAvailableVariant.id}" aria-label="Add ${title} to cart">
                        </div>
                      </div>
                      ${optionsHtml ? `<div class="upsell-bottom-row">${optionsHtml}</div>` : ''}
                    </div>
                  `;
                });

                if (hasAvailable) {
                  container.innerHTML = html;
                  container.removeAttribute('hidden');
                  this.initUpsellEvents(container);
                }
              }
            })
            .catch(e => console.error("Error fetching upsells:", e));
        }

        initUpsellEvents(container) {
          // Toggle Dropdowns
          container.querySelectorAll('.upsell-custom-trigger').forEach(trigger => {
            trigger.addEventListener('click', (e) => {
              e.stopPropagation(); // Stop bubbling
              const currentSelect = trigger.closest('.upsell-custom-select');
              
              // Close other open dropdowns in the same container
              container.querySelectorAll('.upsell-custom-options.open').forEach(opt => {
                if (opt.parentElement !== currentSelect) opt.classList.remove('open');
              });

              const optionsEl = currentSelect.querySelector('.upsell-custom-options');
              optionsEl.classList.toggle('open');
            });
          });

          // Close on outside click
          document.addEventListener('click', (e) => {
             if (!e.target.closest('.upsell-custom-select')) {
                container.querySelectorAll('.upsell-custom-options.open').forEach(opt => opt.classList.remove('open'));
             }
          });

          // Handle Option Selection
          container.querySelectorAll('.upsell-custom-option').forEach(optionEl => {
             optionEl.addEventListener('click', (e) => {
                e.stopPropagation();
                const selectEl = optionEl.closest('.upsell-custom-select');
                const card = selectEl.closest('.upsell-card');
                const triggerSpan = selectEl.querySelector('.upsell-custom-trigger span');
                const optionsList = selectEl.querySelector('.upsell-custom-options');
                
                // Update Selected Value UI
                const newValue = optionEl.dataset.value;
                const isColor = selectEl.dataset.optionName.toLowerCase() === 'color';
                
                // Update trigger text/swatch
                triggerSpan.innerHTML = `
                  ${newValue}
                  ${isColor ? `<span class="upsell-swatch color-${newValue.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '')}"></span>` : ''}
                `;
                
                // Update selected class in list
                selectEl.querySelectorAll('.upsell-custom-option').forEach(opt => opt.classList.remove('selected'));
                optionEl.classList.add('selected');
                
                // Close dropdown
                optionsList.classList.remove('open');

                // Logic to update Card State (Price, Image, Variant ID) based on ALL selections
                this.updateUpsellCard(card);
             });
          });
        }

        updateUpsellCard(card) {
           const variants = JSON.parse(card.dataset.variants);
           const selectors = card.querySelectorAll('.upsell-custom-select');
           
           // Gather current selections
           // We assume the order of selectors matches option1, option2, etc.
           // data-option-index is 0-based.
           const currentOptions = {};
           selectors.forEach(sel => {
              const index = parseInt(sel.dataset.optionIndex);
              const val = sel.querySelector('.upsell-custom-option.selected').dataset.value;
              currentOptions[`option${index + 1}`] = val; // option1, option2...
           });
           
           // Find matching variant
           const match = variants.find(v => {
              // Check if all existing options match
              // variants have option1, option2, option3
              let isMatch = true;
              for (const [key, val] of Object.entries(currentOptions)) {
                 if (v[key] !== val) isMatch = false;
              }
              return isMatch;
           });

           const priceEl = card.querySelector('.upsell-price');
           const imgEl = card.querySelector('.upsell-image');
           const checkbox = card.querySelector('input[type="checkbox"]');
           
           if (match) {
             // Update UI
             priceEl.textContent = '$' + (match.price / 100).toFixed(2).replace(/\.00$/, '');
             if (match.featured_image && match.featured_image.src) {
                imgEl.src = match.featured_image.src;
             }
             checkbox.value = match.id;
             checkbox.id = `upsell-${match.id}`;
             
             // If unavailable
             if (!match.available) {
                // Could disable or show text. For now let's just opacity
                priceEl.innerHTML += ' <span style="font-size:0.8em; color:red;">(Sold Out)</span>';
                checkbox.disabled = true;
                checkbox.checked = false; // Uncheck if sold out
             } else {
                checkbox.disabled = false;
             }
             
             card.dataset.variantId = match.id;
           } else {
             // Variant doesn't exist (e.g. combination invalid)
             priceEl.textContent = 'Unavailable';
             checkbox.disabled = true;
             checkbox.checked = false;
             card.removeAttribute('data-variant-id');
           }
        }
      showOnlyAvailableColors() {
        const t = this.swatch.querySelectorAll('input[name="Color"]');
        window.theme.hideUnavailableWeights &&
          t &&
          t.forEach((t) => {
            window.theme.product.variants.find(
              (e) => e.options[0] === t.value && e.available
            ) || t.nextElementSibling.setAttribute("hidden", "");
          });
      }
      handleLables() {
        if ("Gift Card" !== window.theme.product.type && this.productLabel) {
          if (this.currentVariant.available) {
            this.productLabel.innerHTML = this.currentVariant.variant_label || "";
          } else {
            // If tag exists, keep showing it even if not available
            if (this.currentVariant.variant_label) {
              this.productLabel.innerHTML = this.currentVariant.variant_label;
            } 
          }
          this.productLabel.style.background =
            this.currentVariant.variant_label_color || "";
        }
      }
      handleScroll() {
        const toggleContainer = this.shopBarToggleContainer;
        const t = this.parentElement,
          i = this.formVisible();
        
        if (i) {
          // Form is visible - hide toggle container
          if (t.style.minHeight !== "") {
            t.style.minHeight = "";
          }
          toggleContainer.style.display = "none";
          this.classList.remove("shop-bar");
        } else {
          // Form is not visible - show toggle container
          if (t.style.minHeight === "") {
            t.style.minHeight = t.offsetHeight + "px";
          }
          toggleContainer.style.display = "flex";
          this.classList.add("shop-bar");
        }
      }
      formVisible() {
        let t = this.wrapper.offsetTop - 70,
          e = this.wrapper.offsetLeft,
          i = this.wrapper.offsetWidth,
          r = this.wrapper.offsetHeight;
        return (
          t < window.pageYOffset + window.innerHeight &&
          e < window.pageXOffset + window.innerWidth &&
          t + r > window.pageYOffset &&
          e + i > window.pageXOffset
        );
      }
      handleForm(t) {
        if ((t.preventDefault(), this.submitting)) return;
        this.submitting = !0;
        const e = this.querySelector('[type="submit"]');
        e && (e.setAttribute("disabled", "true"), e.classList.add("loading"));

        // Check if button has link-to-checkout class
        const shouldRedirectToCheckout = e && e.classList.contains("link-to-checkout");

        if (window.theme.product.template == "biscuit-bundle") {
          const formData = window.theme.utils.serializeForm(this.form);
          const i = JSON.stringify([formData]);
          fetch("/cart/add", { ...window.theme.fetchConfig(), body: i })
            .then((t) => t.json())
            .then((t) => {
              if (shouldRedirectToCheckout) {
                window.location.href = "/checkout";
              } else {
                window.theme.cart.render(t, !0); // Pass the response to the render function
              }
            })
            .catch((e) => {
              // Removed console.error
              t.target.submit();
            })
            .finally(() => {
              (this.submitting = !1),
                e &&
                  (e.classList.remove("loading"),
                  e.removeAttribute("disabled"));
              if (!shouldRedirectToCheckout) {
                const t = document.querySelector(".close");
                t && t.click();
              }
            });
        } else {
            const upsellCheckboxes = this.querySelectorAll('.upsell-card input:checked');
            
            if (upsellCheckboxes.length > 0) {
              const formData = JSON.parse(window.theme.utils.serializeForm(this.form));
              const items = [{
                id: formData.id,
                quantity: formData.quantity || 1,
                properties: formData.properties || {}
              }];
              
              upsellCheckboxes.forEach(checkbox => {
                items.push({
                  id: parseInt(checkbox.value),
                  quantity: 1
                });
              });

              fetch(window.Shopify.routes.root + "cart/add.js", {
                ...window.theme.fetchConfig(),
                body: JSON.stringify({ items })
              })
                .then(t => t.json())
                .then(t => {
                  if (shouldRedirectToCheckout) {
                    window.location.href = "/checkout";
                  } else {
                    window.theme.cart.render(!0);
                  }
                })
                .catch(e => {
                  console.error(e);
                  // Fallback to standard submit if something goes wrong? 
                  // Or just alert user. For now, let's keep it simple.
                  t.target.submit();
                })
                .finally(() => {
                  (this.submitting = !1),
                    e && (e.classList.remove("loading"), e.removeAttribute("disabled"));
                  if (!shouldRedirectToCheckout) {
                    const t = document.querySelector(".close");
                    t && t.click();
                  }
                });
            } else {
              // Standard single item add
              const i = JSON.stringify({
                ...JSON.parse(window.theme.utils.serializeForm(this.form)),
              });
              fetch("/cart/add", { ...window.theme.fetchConfig(), body: i })
                .then((t) => t.json())
                .then((t) => {
                  if (shouldRedirectToCheckout) {
                    window.location.href = "/checkout";
                  } else {
                    window.theme.cart.render(!0);
                  }
                })
                .catch((e) => {
                  // Removed console.error
                  t.target.submit();
                })
                .finally(() => {
                  (this.submitting = !1),
                    e &&
                      (e.classList.remove("loading"),
                      e.removeAttribute("disabled"));
                  if (!shouldRedirectToCheckout) {
                    const t = document.querySelector(".close");
                    t && t.click();
                  }
                });
            }
        }
      }
      onVariantChange() {
        this.updateOptions(),
          this.updateMasterId(),
          this.updateMedia(),
          this.checkAvailability(),
          this.updateURL(),
          this.updateVariantInput(),
          (window.theme.product.currentVariant = this.currentVariant),
          this.changeElements(),
          this.handleLables(),
          this.handleLpColors(),
          this.updateAfterpay(),
          this.currentVariant.options.forEach((t, e) => {
            this.setAttribute(`data-option${e + 1}`, t);
          }),
          40597836693690 === this.currentVariant.id
            ? this.button.classList.add("hidden")
            : this.button.classList.remove("hidden"),
          "product" in this.currentVariant &&
            (window.theme.product.title = this.currentVariant.product),
          this.updateAffirm(),
          this.noSelect &&
            !this.select.hasAttribute("open") &&
            (this.select.setAttribute("selected", ""), (this.noSelect = !1));
      }
      updateAfterpay() {
        if (this.afterPayPrice) {
          const t = this.currentVariant.price;
          this.afterPayPrice.dataset.mobilePrice = t;
        }
      }
      updateAffirm() {
        if (
          this.affirmText &&
          "undefined" != typeof affirm &&
          affirm.jsReady()
        ) {
          const t = this.currentVariant.price.replace("$", "") + "00";
          this.affirmText.setAttribute("data-amount", t), affirm.ui.refresh();
        }
      }
      updateOptions() {
        // Build options array based on product.options order, not DOM order
        // This ensures this.options[i] matches variant.options[i]
        if (window.theme.product.options) {
          this.options = window.theme.product.options.map((optionName) => {
            const input = this.swatch.querySelector(`input[name="${optionName}"]:checked`);
            return input ? input.value : false;
          });
        } else {
          // Fallback to old method if options not available
          const t = Array.from(this.swatch.querySelectorAll("fieldset"));
          this.options = t.map((t) => {
            const e = Array.from(t.querySelectorAll("input")).find(
              (t) => t.checked
            );
            return !!e && e.value;
          });
        }
        
        window.theme.product.landing && this.options.shift();
      }
      updateMasterId() {
        const t = window.theme.hideUnavailableWeights,
          e = this.currentVariant.sizes.join(",");
        const isBodyPillow = window.location.pathname.includes('body-pillow') || 
                           (window.theme.product && window.theme.product.handle === 'body-pillow');
        if (
          ((this.currentVariant = window.theme.product.variants.find(
            (t) => !t.options.map((t, e) => this.options[e] === t).includes(!1)
          )),
          this.currentVariant ||
            (this.currentVariant = window.theme.product.variants.find(
              (t) => t.options[0] === this.options[0]
            )),
          t &&
            "Color" === window.theme.product.options[0] &&
            "Weight (lbs)" === window.theme.product.options[1])
        ) {
          this.setAttribute("data-hide-weights", "true");
          const t = this.querySelectorAll(
            'input[name="' + window.theme.product.options[1] + '"]'
          );
          
          if (0 === t.length) return;
          
          for (var i = 0; i < t.length; i++) {
            var r = t[i];
            const e = r.value;
            var o = r.nextElementSibling;
            
            const availableVariant = window.theme.product.variants.find(
              function (variant) {
                return (
                  variant.options[1] === e &&
                  variant.options[0] === this.currentVariant?.options?.[0] &&
                  variant.available
                );
              }.bind(this)
            );
            
            availableVariant
              ? o.removeAttribute("hidden")
              : o.setAttribute("hidden", "");
          }
          const e = this.querySelector(
            'input[name="' +
              window.theme.product.options[1] +
              '"] + label:not([hidden])'
          );
          !this.currentVariant?.available && e && e.click();
        } else if (this.currentVariant.sizes.join(",") !== e) {
          this.querySelector(
            'input[value="' + this.currentVariant.options[1] + '"]'
          ).click(),
            (this.options = this.currentVariant.options);
          let t = this.querySelectorAll(
            'input[name="' + window.theme.product.options[1] + '"]'
          );
          if (0 === t.length) return;
          for (let e = 0; e < t.length; e++) {
            const i = t[e],
              r = i.nextElementSibling;
            this.currentVariant.sizes.includes(i.value)
              ? r.removeAttribute("hidden")
              : r.setAttribute("hidden", "");
          }
        }
      }
      updateMedia() {
        if ("Sleeper" !== window.theme.product.title) {
          if ("Gift Card" === window.theme.product.type) {
            const t = window.theme.product.images[this.currentVariant.color][1];
            (this.image.src = t.src),
              (this.image.alt = t.alt),
              this.updateGallery(
                window.theme.product.images[this.currentVariant.color]
              );
          } else {

            const isOceanNapper = window.location.pathname.includes('ocean-napper') || 
                                (window.theme.product && window.theme.product.handle === 'ocean-napper');
            const isHuggerSelected = isOceanNapper && this.currentVariant.options && 
                                    (this.currentVariant.options.includes('Queen 20') || this.currentVariant.options.includes('King 25'));

            const isBodyPillow = window.location.pathname.includes('body-pillow') || 
                                (window.theme.product && window.theme.product.handle === 'body-pillow');
            const isMediumSelected = isBodyPillow && this.currentVariant.options && 
                                    (this.currentVariant.options.includes('54"') || this.currentVariant.options.includes('Medium'));
            let t;
            if (isMediumSelected) {
              const mediumColorKey = 'medium-' + this.currentVariant.color;
              t = window.theme.product.landing
                ? window.theme.product.images[this.currentVariant.product][mediumColorKey]
                : window.theme.product.images[mediumColorKey];
                console.log('t1',t, mediumColorKey);
              if (!t) {
                t = window.theme.product.landing
                  ? window.theme.product.images[this.currentVariant.product][this.currentVariant.color]
                  : window.theme.product.images[this.currentVariant.color];
              }
            } else {
              t = window.theme.product.landing
                ? window.theme.product.images[this.currentVariant.product][this.currentVariant.color]
                : window.theme.product.images[this.currentVariant.color];
            }
             if (isHuggerSelected) {
              const huggerColorKey = 'hugger-' + this.currentVariant.color;
              t = window.theme.product.landing
                ? window.theme.product.images[this.currentVariant.product][huggerColorKey]
                : window.theme.product.images[huggerColorKey];
              console.log('t1',t, huggerColorKey);
              if (!t) {
                t = window.theme.product.landing
                  ? window.theme.product.images[this.currentVariant.product][this.currentVariant.color]
                  : window.theme.product.images[this.currentVariant.color];
              }
            } else {
              t = window.theme.product.landing
                ? window.theme.product.images[this.currentVariant.product][this.currentVariant.color]
                : window.theme.product.images[this.currentVariant.color];
            }
            t &&
              (this.gallery.update(t, window.theme.product.video),
              this.gallery2 &&
                this.gallery2.update(t, window.theme.product.video),
              this.updateGallery(t));
          }
          (this.imageBar.src = this.currentVariant.image),
            window.theme.product.videoObserverInit &&
              window.theme.product.videoObserverInit();
        }
      }
      updateGallery(t) {
        if ("true" === this.nGallery.dataset.slider || 0 === t.length) return;
        let e = "";
        t.forEach(function (t, i) {
          e += `\n      <div class="product-gallery_item product-gallery_item-image pointer">  \n        <div class="media media--square">\n          <img src="${t.src}" alt="${t.alt}" width="800" height="1000" class="cover-image" loading="lazy" onclick="window.theme.product.modal(${i})">\n        </div>\n      </div>`;
        }),
          window.theme.product.video
            ? (e += `\n    <div class="product-gallery_item product-gallery_item-video pointer">  \n      <div class="media media--square">\n        <video playsinline autoplay loop muted class="cover-image" poster="${window.theme.product.video.image}" onclick="window.theme.product.modal(${t.length})">\n          <source src="${window.theme.product.video.src}" type="video/mp4">\n          Your browser does not support the video tag.\n        </video> \n      </div>\n    </div>`)
            : window.theme.product.videos &&
              window.theme.product.videos[this.currentVariant.product] &&
              (e += `\n    <div class="product-gallery_item product-gallery_item-video pointer">  \n      <div class="media media--square">\n        <video playsinline autoplay loop muted class="cover-image" poster="${
                window.theme.product.videos[this.currentVariant.product].image
              }" onclick="window.theme.product.modal(${
                t.length
              })">\n          <source src="${
                window.theme.product.videos[this.currentVariant.product].src
              }" type="video/mp4">\n          Your browser does not support the video tag.\n        </video> \n      </div>\n    </div>`),
          (this.nGallery.innerHTML = e);
      }
      updateURL() {
        if (window.theme.product.landing) return;
        if (this.firstLoad) return void (this.firstLoad = !1);
        const t = new URLSearchParams(window.location.search);
        t.set("variant", this.currentVariant.id);
        const e = window.location.pathname + "?" + t.toString();
        history.pushState(null, "", e);
      }
      updateVariantInput() {
        (this.input.value = this.currentVariant.id),
          this.input.dispatchEvent(new Event("change", { bubbles: !0 }));
      }
      checkAvailability() {
        this.currentVariant.available
          ? this.removeAttribute("soldout")
          : this.setAttribute("soldout", "");
      }

      changeElements() {
        var additionalText = document.getElementById('product-form_additional-text');
        const isBodyPillow = window.location.pathname.includes('body-pillow') || 
                           (window.theme.product && window.theme.product.handle === 'body-pillow');
        if (window.theme.product.currentVariant.is_preoder === "true") {
          document.querySelector('#product-form_preorder-text').style.display = 'block';
          document.querySelector('#product-form_preorder-text').innerHTML = window.theme.product.currentVariant.preorder_text;
          this.button.innerHTML = "PRE-ORDER";
        } 
        else {
          document.querySelector('#product-form_preorder-text').style.display = 'none';
          this.button.innerHTML = "ADD TO CART";
          document.querySelector('#product-form_additional-text').style.display = 'none';
          additionalText.style.display = 'block';

        }
        const t = document.querySelectorAll(
            ".product-price-compare.compare-price"
          ),
          e = document.querySelectorAll(".tag--save"),
          i = document.querySelectorAll(".compare-price-cart.product-price");
        let r = this.currentVariant.price,
          o = parseFloat(r.replace("$", ""));
        var n = 0;

        if (
          ((o = o.toFixed(0)),
          t.forEach((t) => {
            let r = !1;
            if (window.theme.product.sku_discounts == true) {
              if (window.theme.product.currentVariant.discount != "") {
                const isFixedDiscount = window.theme.product.currentVariant.is_fixed_discount;
                let discountedPrice;
                
                if (isFixedDiscount) {
                  // Fixed dollar amount discount
                  const discountAmount = parseFloat(window.theme.product.currentVariant.discount) * 100;
                  discountedPrice = o - discountAmount;
                  n = discountedPrice / o; // for compatibility
                } else {
                  // Percentage discount
                  n = 1 - window.theme.product.currentVariant.discount / 100;
                  discountedPrice = o * n;
                }
                
                e.forEach((e) => {
                  e.dataset.textDiscount = isFixedDiscount 
                    ? "$" + window.theme.product.currentVariant.discount + " off"
                    : window.theme.product.currentVariant.discount + "% off";
                  e.style.display = "flex";
                });
                i.forEach((i) => {
                  i.style.display = "";
                }),
                  (document.querySelector(
                    ".discount-additional-text-wrapper"
                  ).style.display = "block");
                this.save_additional.innerHTML = isFixedDiscount
                  ? "Save $" + window.theme.product.currentVariant.discount + " "
                  : "Save " + window.theme.product.currentVariant.discount + "% ";
                t.classList.add("red"),
                  (t.innerHTML = `$${Math.round(discountedPrice)}`),
                  (this.button.dataset.mobilePrice = `$${Math.round(discountedPrice)}`),
                  (this.button.setAttribute('data-mobile-price' , `$${Math.round(discountedPrice)}`));
              } else {
                e.forEach((e) => {
                  e.style.display = "none";
                });
                t.innerHTML = this.currentVariant.price;
                t.classList.remove("red");
                i.forEach((i) => {
                  i.style.display = "none";
                });
                const discountWrapper = document.querySelector(".discount-additional-text-wrapper");
                if (discountWrapper) {
                  discountWrapper.style.display = "none";
                }
                this.button.dataset.mobilePrice = this.currentVariant.price;
              }
            } else {
              this.specialDiscount.forEach((o) => {
                if (o.innerHTML == window.theme.product.currentVariant.id)
                  return (
                    (n = 1 - o.dataset.specialDiscount / 100),
                    t.classList.add("red"),
                    (document.querySelector(
                      ".discount-additional-text-wrapper"
                    ).style.display = "block"),
                    (this.save_additional.style.display = "inline-block"),
                    (i[0].style.display = "block"),
                    e.forEach((t) => {
                      (t.dataset.textDiscount =
                        o.dataset.specialDiscount + "% off"),
                        (t.style.display = "flex"),
                        (this.save_additional.innerHTML =
                          "Save " + o.dataset.specialDiscount + "% ");
                    }),
                    void (r = !0)
                  );
              }),
                r ||
                  (() => {
                    const isFixed = t.dataset.isFixed === "true";
                    let discountedPrice;
                    
                    if (isFixed) {
                      const discountAmount = parseFloat(t.dataset.discount) * 100;
                      discountedPrice = o - discountAmount;
                      n = discountedPrice / o;
                    } else {
                      n = 1 - t.dataset.discount / 100;
                      discountedPrice = o * n;
                    }
                    
                    t.classList.add("red");
                    document.querySelector(".discount-additional-text-wrapper").style.display = "block";
                    this.save_additional.style.display = "inline-block";
                    i[0].style.display = "block";
                    this.save_additional.innerHTML = isFixed
                      ? "Save $" + t.dataset.discount + " "
                      : "Save " + t.dataset.discount + "% ";
                    e.forEach((e) => {
                      e.dataset.textDiscount = isFixed
                        ? "$" + t.dataset.discount + " off"
                        : t.dataset.discount + "% off";
                      e.style.display = "flex";
                    });
                    t.innerHTML = `$${Math.round(discountedPrice)}`;
                    this.button.dataset.mobilePrice = `$${Math.round(discountedPrice)}`;
                  })();
            }
          }),
          this.prices.forEach((t) => {
            t.innerHTML = this.currentVariant.price;
          }),
          this.priceDiscount.forEach((t) => {
            let e = parseFloat(
                this.currentVariant.price.replace(/[^0-9.-]+/g, "")
              ),
              i = Math.ceil(1.11 * e);
            t.innerHTML = "$" + i.toFixed(0);
          }),
          (this.SignButton.dataset.unitPrice = this.currentVariant.price),
          (this.button.dataset.bundlePrice = this.currentVariant.price),
          (this.button.dataset.unitPrice = this.currentVariant.price),
          this.option1 &&
            (this.option1.innerHTML = window.theme.product.title === "Cuddler"
              ? this.currentVariant.options[0].replaceAll('Body Pillow', '').replaceAll('(', '').replaceAll(')', '').trim()
              : this.currentVariant.options[0]),
          window.theme.product.options[1] &&
            window.theme.product.options[1].includes("Weight"))
        )
          this.option3 &&
            (this.option3.innerHTML = this.currentVariant.options[2]),
            this.option2 &&
              (this.option2.innerHTML =
                this.currentVariant.options[1]
                  .replace("Queen ", "")
                  .replace("King ", "") +
                " lbs " +
                window.theme.getDimension(this.currentVariant.options[1]));
        else if (
          "Size" === window.theme.product.options[0] &&
          "Sleeper" === window.theme.product.title
        )
          this.option1 &&
            (this.option1.innerHTML =
              this.currentVariant.options[0] +
              window.theme.getDimension(this.currentVariant.options[0]));
        else if (
          window.theme.product.options[1] &&
          "Size" === window.theme.product.options[1] &&
          "Gift Card" !== window.theme.product.type
        ) {
          let t = this.currentVariant.options[1];
          "Small" === t && "Pupper Pod" === window.theme.product.title
            ? (t = "Small1")
            : "Medium" === t &&
              "Pupper Pod" === window.theme.product.title &&
              (t = "Medium1"),
            this.option2 &&
              (this.option2.innerHTML =
                this.currentVariant.options[1] + window.theme.getDimension(t));
        } else
          this.option2 &&
            (this.option2.innerHTML = this.currentVariant.options[1]);
        if (
          (this.option0 &&
            ((this.option0.innerHTML = this.currentVariant.product),
            (this.option0.href =
              window.theme.product.urls[this.currentVariant.product] || "")),
          window.theme.extraColors && this.productLabel)
        ) {
          const t = window.theme.extraColors.includes(
              this.currentVariant.options[0]
            ),
            e = this.option1
              .closest(".form__label")
              .classList.contains("form__label--2");
          t && !e
            ? (this.swatch
                .querySelector(".form__label--2")
                .appendChild(this.option1),
              this.swatch
                .querySelector(".form__label--2")
                .appendChild(this.productLabel))
            : !t &&
              e &&
              (this.swatch
                .querySelector(".form__label--1")
                .appendChild(this.option1),
              this.swatch
                .querySelector(".form__label--1")
                .appendChild(this.productLabel));
        }
      }
      handleSelect(t) {
        "INPUT" !== t.target.tagName &&
          (this.select.hasAttribute("open")
            ? this.select.removeAttribute("open")
            : this.select.setAttribute("open", ""));
      }
      handleLpColors() {
        const t = this.querySelector('[name="Type"]:checked');
        "weight-lp" === this.dataset.type &&
          t &&
          (this.querySelectorAll(".swatch-color label:not([hidden])").forEach(
            (e) => {
              e.dataset.product === t.value
                ? e.classList.remove("d-none")
                : e.classList.add("d-none");
            }
          ),
          this.querySelector('[name="Color"]:checked + label.d-none') &&
            this.querySelector(
              '[name="Color"] + label:not(.d-none):not([hidden])'
            ).click());
      }
    }
    customElements.define("product-form", t);
    
    (function () {
        var t = document.querySelector("#product-zoom-modal");
        if (t) {
          const r = t.querySelector("img"),
            o = t.querySelector("video"),
            n = t.querySelector(".slider-next"),
            s = t.querySelector(".slider-prev");
          function e(t) {
            let e,
              i = parseInt(r.dataset.index);
            e = window.theme.product.landing
              ? window.theme.product.images[
                  window.theme.product.currentVariant.product
                ][window.theme.product.currentVariant.color]
              : "Sleeper" === window.theme.product.title
              ? window.theme.product.images.sleeper
              : window.theme.product.images[
                  window.theme.product.currentVariant.color
                ];
            const n = e.length - 1;
            if (o && (("next" === t && i === n) || ("prev" === t && 0 === i))) {
              o.removeAttribute("hidden");
              const t = o.play();
              return (
                void 0 !== t &&
                  t.catch(function (t) {
                    /* removed console.log */
                  }),
                void (r.dataset.index = e.length.toString())
              );
            }
            "next" === t
              ? i >= n
                ? (i = 0)
                : i++
              : "prev" === t && (0 === i ? (i = n) : i--),
              (r.src = ""),
              o && !o.paused && (o.pause(), o.setAttribute("hidden", "")),
              (r.src = e[i].src),
              (r.dataset.index = i.toString());
          }
          (window.theme.product.modal = function (e) {
            let i;
            if (
              ((i = window.theme.product.landing
                ? window.theme.product.images[this.currentVariant.product][
                    this.currentVariant.color
                  ]
                : "Sleeper" === window.theme.product.title
                ? window.theme.product.images.sleeper
                : window.theme.product.images[this.currentVariant.color]),
              i)
            ) {
              if (e === i.length) {
                o.removeAttribute("hidden");
                const t = o.play();
                void 0 !== t &&
                  t.catch(function (t) {
                    /* removed console.log */
                  });
              } else {
                (r.src = ""),
                  o && !o.paused && (o.pause(), o.setAttribute("hidden", ""));
                const t = i[e];
                r.src = t.src.replace("_800x", "");
              }
              (r.dataset.index = e.toString()),
                document.body.classList.add("body_fade"),
                document.body.classList.add("header_fade"),
                t.setAttribute("open", "");
            }
          }),
            n.addEventListener("click", function () {
              e("next");
            }),
            s.addEventListener("click", function () {
              e("prev");
            });
        }
        const i = new IntersectionObserver(
          (t) => {
            t.forEach((t) => {
              const e = t.target;
              if (t.isIntersecting) {
                const t = e.play();
                void 0 !== t &&
                  t.catch(function (t) {
                    /* removed console.log */
                  });
              } else e.pause();
            });
          },
          { threshold: 0.2 }
        );
        document.querySelectorAll(".product-gallery video").forEach((t) => {
          i.observe(t);
        });
      })();
  })();
  const t = document.querySelectorAll("[data-tab-target]"),
    e = document.querySelectorAll("[data-tab-content]");
  t.forEach((i) => {
    i.addEventListener("click", () => {
      const r = document.querySelector(i.dataset.tabTarget);
      e.forEach((t) => {
        t.classList.remove("active");
      }),
        t.forEach((t) => {
          t.classList.remove("active");
        }),
        i.classList.add("active"),
        r.classList.add("active");
    });
  });
  class i extends HTMLElement {
    constructor() {
      super(),
        (this.originalHTML = this.innerHTML),
        (this.originalTextContent = this.textContent);
    }
    static get observedAttributes() {
      return ["limit", "open"];
    }
    get less() {
      return this.getAttribute("less");
    }
    get more() {
      return this.getAttribute("more");
    }
    get limit() {
      return this.hasAttribute("limit")
        ? Number(this.getAttribute("limit"))
        : 10;
    }
    get isOpen() {
      return this.hasAttribute("open");
    }
    attributeChangedCallback(t, e, i) {
      this.render();
    }
    render() {
      this.textContent.length > this.limit &&
        (this.isOpen
          ? ((this.innerHTML = this.originalHTML),
            (this.querySelector("p:last-child").innerHTML = `\n          ${
              this.querySelector("p:last-child").innerHTML
            }\n          <button type="button">${
              this.less
            }</button>\n        `))
          : (this.innerHTML = `\n          <p>\n            ${this.originalTextContent
              .trim()
              .slice(
                0,
                this.limit
              )}&hellip;\n            <button type="button">${
              this.more
            }</button>\n          </p>\n        `),
        this.querySelector("button")?.addEventListener(
          "click",
          this.toggle.bind(this)
        ));
    }
    toggle(t) {
      this.toggleAttribute("open");
    }
  }
  customElements.define("read-more", i);
})();
